class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.handleEscape = (event) => {
      if (event.key === 'Escape') {
        document.dispatchEvent(new CustomEvent('modal-event-cart-drawer-close', { detail: this.lastCartUpdate }));
      }
    };
    this.handleCloseClick = (event) => {
      if (event.target.closest && event.target.closest('[data-cart-drawer-close-button]')) {
        document.dispatchEvent(new CustomEvent('modal-event-cart-drawer-close', { detail: this.lastCartUpdate }));
      }
    };
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    document.addEventListener('keydown', this.handleEscape);
    document.addEventListener('click', this.handleCloseClick);
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (obj) => {
      if (/cart/.test(window.location.href)) return

      if (window.innerWidth < 769) return

      this.lastCartUpdate = obj;
      clearInterval(this.checkElementInterval);
      clearInterval(this.checkCloseInterval);
      clearTimeout(this.closeTimeout);

      document.dispatchEvent(new CustomEvent('modal-event-cart-drawer-open', { detail: obj }));

      function trapKeyboardFocus() {
        const cartModalInner = document.querySelector('.drawer__inner')
        const firstFocusableElement = cartModalInner?.querySelector('.drawer__heading')
        const lastFocusableElement = cartModalInner?.querySelector('#CartDrawer-Checkout')
        if (cartModalInner && firstFocusableElement && lastFocusableElement && !cartModalInner.dataset.focusTrapBound) {
          cartModalInner.dataset.focusTrapBound = 'true';
          cartModalInner.addEventListener('keydown', function(e) {
            if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
              e.preventDefault()
              lastFocusableElement.focus()
            } else if(e.target == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
              e.preventDefault()
              firstFocusableElement.focus()
            }
          })
        }
        
      }

      const checkElementIntervalTimer = () => {
          const cartDrawerHead = document.querySelector('.drawer__heading')
          if (cartDrawerHead) {
            cartDrawerHead.setAttribute('tabindex', '-1')
            cartDrawerHead.focus()
            trapKeyboardFocus()
            clearInterval(this.checkElementInterval)
            this.checkElementInterval = null
          }
      }
      this.checkElementInterval = setInterval(checkElementIntervalTimer, 300)

      const checkCloseIntervalTimer = () => {
          const closeCartDrawerButton = document.querySelector('[data-cart-drawer-close-button]')
          if (closeCartDrawerButton) {
            closeCartDrawerButton.classList.remove('hidden')
            clearInterval(this.checkCloseInterval)
            this.checkCloseInterval = null
          }
      }
      this.checkCloseInterval = setInterval(checkCloseIntervalTimer, 300)

      this.closeTimeout = setTimeout(() => {
        document.dispatchEvent(new CustomEvent('modal-event-cart-drawer-close', { detail: obj }));
        this.closeTimeout = null
      }, 4000)
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
    document.removeEventListener('keydown', this.handleEscape);
    document.removeEventListener('click', this.handleCloseClick);
    clearInterval(this.checkElementInterval);
    clearInterval(this.checkCloseInterval);
    clearTimeout(this.closeTimeout);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (cartLink) cartLink.setAttribute('role', 'button');
    // cartLink.setAttribute('aria-haspopup', 'dialog');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedElement = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return parsedElement ? parsedElement.innerHTML : null; // Ensure that parsedElement is not null before accessing innerHTML
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (sectionElement) {
        sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
      }
    });

  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
      {
        id: 'checkout-footer',
        selector: '#mobile-bottom-cart',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'checkout-footer',
        section: 'checkout-footer',
        selector: '#mobile-bottom-cart', // Adjusted to use ID selector
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
